'use strict';

angular.module('clientDashboardApp').directive('collapseIcon',function(){
  return {
    restrict: 'E',
    scope: {
      collapse: '='
    },
    template: `<span class="fas collapse-icon" ng-class="{'fa-caret-down' : !collapse, 'fa-caret-right' : collapse}"></span>`
  }
})
